<template lang="pug">
    section#pontualidade
        .wrapper
            div.img
                img(:src="require('@images/backgrounds/fundo-desconto-bolsas.png')")
            div.texto
                h2
                    |DESCONTO PONTUALIDADE
                p
                    |Além da possibilidade da bolsa PROFAEL, todo aluno UniFAEL tem garantido o Desconto
                    |Pontualidade para pagamentos antecipados da mensalidade durante o mês de vencimento.
                    |O desconto pode chegar a 29% e para ganhar basta quitar o seu boleto até o dia 5 de cada
                    |mês. Mais uma forma de economizar com a UniFAEL!
</template>

<script>
export default {
    name: "section-pontualidade"
}
</script>

<style lang="stylus" scoped src="./Pontualidade.styl"></style>
